export class AddCustomerEmployeeContactInput {
    public contact: string;
    public isDefault: boolean;
    public contactTypeId: number | null;

    constructor() {
        this.contact = '';
        this.isDefault = false;
        this.contactTypeId = null;
    }
}